export const cpfMask = (value: string | undefined) => {
  if (value === undefined) return value
  if (value.match(/^\d{11}/) != null) {
    return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4')
  } else return value
}

export const dateMask = (value: Date | string | undefined) => {
  if (value === undefined) return value
  const result = value.toString().replace(/(\d{4})-(\d{2})-(\d{2})/, '$3/$2/$1')
  return result
}

export const addressMask = (value: string | undefined) => {
  if (value === undefined) return value
  return value?.replace(/<br>/g, '\n')
}

export const telMask = (value: string) => {
  const newValue = value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d+)(\d{4})/, '($1) $2-$3')

  return newValue
}
